<form action="{{SANDBOX_URL}}" method="post">
    <input type="hidden" name="html" value="{{html}}">
    <input type="hidden" name="scale" value="{{scale}}">
    <input type="hidden" name="format" value="{{format}}">
    <input type="hidden" name="title" value="{{title}}">
    <input type="hidden" name="device_dimension" value="{{device_dimension}}">
    <input type="hidden" name="ad_dimension" value="{{ad_dimension}}">
</form>
